import React, { FC, useState,useEffect } from 'react';
import Spinner from '../../Spinner/Spinner';
import { fetchPullRepositorys, fetchSearchRepositorys} from '../../../redux/slices/RepositorysSlice';
import { useAppDispatch, useAppSelector} from '../../../redux/store/store';
import './ListRepositories.css';
import { Link, useNavigate } from 'react-router-dom';
import { refreshToken2 } from '../../../refreshToken2';
import { useMsal } from '@azure/msal-react';

type InputListItem = { key: string; value: string };
const ListRepositories = () => {
  const storedRepositories = JSON.parse(sessionStorage.getItem("allowedRepositories") || "[]");
  // console.log("allowed store****:",storedRepositories);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showInputs, setShowInputs] = useState(false);
  const [inputList, setinputList]= useState([{key:'', value:''}]);
  const [repositoryName, setRepositoryName] = useState('');
  const [showTable, setShowTable] = useState(false);
  const [selectedValue, setSelectedValue] = useState<string | number>(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [take, setTake] = useState(10);
  const repositoryID= sessionStorage.getItem('groupAllowedRepository');
  const totalPages = ((sessionStorage.getItem('total-pages') != null) ? +sessionStorage.getItem('total-pages')! : 0);
  const { instance } = useMsal();
  
  
  useEffect(() => {
    loadContent();
  }, [take]);

  const loadContent = async () => {
    await refreshToken2(instance);
    // instance
    // .handleRedirectPromise()
    // .then((tokenResponse) => {
    //     if (!tokenResponse) {
    //         const accounts = instance.getAllAccounts();
    //         if (accounts.length === 0) {
    //             // No user signed in
    //             instance.loginRedirect();
    //         }
    //     } else {
    //         console.log("entra en el refreshtoken");
    //         sessionStorage.setItem('idToken', tokenResponse.idToken);
    //         sessionStorage.setItem('accessToken', tokenResponse.accessToken);
    //     }
    // })
    // .catch((err) => {
    //     // Handle error
    //     console.error(err);
    // });
    await dispatch(fetchPullRepositorys({ Page: page, Take: take}));
  };

const handlePageChange = (Page: number) => {
  if(Page >0 && Page <= totalPages){
    setPage(Page);
    dispatch(fetchPullRepositorys({ Page: Page, Take: take }));
  }  
};

const handleTakeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
  event.preventDefault();
  const newTake = Number(event.target.value);
  setTake(newTake);
  // console.log("Este es el Take:", newTake);
  dispatch(fetchPullRepositorys({ Page: page, Take: newTake }));
};
  


  const handleOnBlur = () => {
    if (!repositoryName) {
      dispatch(fetchPullRepositorys({ Page: page, Take: take }));
    }
  }

  const GetAccess = ({ repositoryId, repositoryName, repositoryDescription, repositoryFilter }: { repositoryId: string, repositoryName: string, repositoryDescription: string, repositoryFilter: any }) => {
    const id = repositoryId;
    const name = repositoryName;
    const description = repositoryDescription;
    const metadata = repositoryFilter;
    console.log(id, name, description, metadata);
    sessionStorage.setItem('selectedRepositoryId', id);
    sessionStorage.setItem('selectedRepositoryName', name);
    sessionStorage.setItem('selectedRepositoryDescription', description);
    sessionStorage.setItem('selectedRepositoryMetadata', metadata);
    console.log('============ REDIRECT LOG: [ListRepositories] - Navigate to /repositories/get-access');
    navigate('/repositories/get-access')
  };
  
const GetRepositoryByName = (repositoryName: any) => {
  console.log('GetRepositoryByName:', repositoryName);
  dispatch(fetchSearchRepositorys(repositoryName));
}

const handleKeyDown = (e:any) => {
  if (e.keyCode === 13) {
    e.preventDefault();
    GetRepositoryByName(repositoryName);
  }
};

  const paging = useAppSelector(state => state.RepositorysSlice.paging);
  const resultsearch: { id: string, name: string, description: string, businessUnitId: string, filters: any[] }[] = useAppSelector(state => state.RepositorysSlice.result);
  // console.log("este es el result search*****",resultsearch); 
  const result: { id: string, name: string, description: string, businessUnitId: string, filters: any[] }[] = useAppSelector(state => state.RepositorysSlice.result);
  console.log("este es el result",result); 
  console.log("este es el inputlist:",inputList[0]); 
  

return  loading ? <Spinner/>: (
  <div className="tablemerepositories">
<div className="pds-dataTable pds-dataTable-flexible table-merepositories">
  <div className="pds-dataTable-header">
  <p aria-hidden="true" className="pds-dataTable-title pds-typography-eyebrow-1">Solicitud de Acceso a Repositorio</p>
    <div className="pds-searchInput pds-dataTable-smart-search">
      <input aria-label="Filter table data search bar" className="search inputSearch pds-input-small" onKeyDown={handleKeyDown} onChange={(e) => setRepositoryName(e.target.value)}  onBlur={handleOnBlur} type="search" placeholder="Busqueda por nombre de repositorio"/>
      <button type="submit" onClick={() => GetRepositoryByName(repositoryName)} aria-label="Search" />
    </div>
  </div>
  <div className="pds-dataTable-table-container pds-table-scrolling ">
    <table className="pds-table-container pds-table pds-table-bordered tablerepo" id="pds-datatable-flexible-example" aria-live="polite">
      <caption className="sr-only">Title</caption>
      <thead>
        <tr>
          <th className="sort  title-header pds-typography-eyebrow-2" scope="col">&nbsp;Nombre&nbsp;del&nbsp;Repositorio</th>
          <th className="sort  title-header pds-typography-eyebrow-2" scope="col">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Descripcion</th>
          <th className="sort  title-header pds-typography-eyebrow-2" scope="col" colSpan={2}>&nbsp;&nbsp;&nbsp;Accion</th>
        </tr>
      </thead>
      {Object.values(result).map((repository, index) => (
      <tbody key={repository.id}>
        <tr key={index}>
        {/* <td className="pds-dataTable-table-item">{repository.id}</td> */}
          <td className="pds-dataTable-table-item">{repository.name}</td>
          <td className="pds-dataTable-table-item">{repository.description}</td>   

<td className="pds-tableActionMenu-actionColumn">
<button disabled={storedRepositories.includes(repository.id)} onClick={() => GetAccess({ repositoryId: repository.id, repositoryName: repository.name, repositoryDescription: repository.description, repositoryFilter: repository.filters })} className="pds-button pds-button-primary ">Solicitar Acceso</button>
  </td>
        </tr>
      </tbody>
       ))}
    </table>
  </div>
  <div className="pds-dataTable-footer">
    <div className="pds-dataTable-show-entries">
      <label className="pds-dataTable-select-label" />
      <div className="pds-select">
      <select
              id=""
              aria-label="Number of rows to display in table" name="entries" className="pds-dataTable-select-options pds-select-small"
              value={take}
              onChange={handleTakeChange}>
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={20}>20</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
            </select>
      </div>
      
    </div>
    <nav
          aria-label="Pagination"
          className="pds-pagination pds-dataTable-pagination"
        >
          <span className="pds-dataTable-previous-buttons pds-dataTable-disable-pagination-buttons">
            <a
              role="link"
              tabIndex={0}
              aria-label="first page"
              aria-disabled={page === 1}
              className={`pds-dataTable-first-page pds-pagination-fly-first page pds-pagination-link ${page === 1 ? 'disabled' : ''
                }`}
              onClick={() => handlePageChange(1)}
            />
            <a
              role="link"
              tabIndex={0}
              aria-label="Previous page"
              aria-disabled={page === 1}
              className={`pds-dataTable-previous pds-pagination-step-forward page pds-pagination-link ${page === 1 ? 'disabled' : '' }`}
              onClick={() => handlePageChange(page - 1)} />
          </span>

          <span className="pds-dataTable-next-buttons">
            <a
              role="link"
              tabIndex={0}
              aria-label="Next page"
              className={`pds-dataTable-next pds-pagination-step-backward page pds-pagination-link ${page === totalPages ? 'disabled' : '' }`}
              onClick={() => handlePageChange(page + 1)}
            />
            <a
              role="link"
              tabIndex={0}
              aria-label="Last page"
              className={`pds-dataTable-last-page pds-pagination-fly-last page pds-pagination-link ${page === totalPages ? 'disabled' : '' }`}
              onClick={() => handlePageChange(totalPages)}
            />
      </span>
    </nav>
  </div>
</div>
</div>
)}

export default ListRepositories;


